import { Box, Fade } from '@mui/material'
import React, { useState } from 'react'
import SangBleu from '../../../frontend-lib/typhograpy/SangBleu'
import BaseButton from '../../../frontend-lib/button/BaseButton'
import ChevronLeftIcon from '../../../frontend-lib/icons/ChevronLeftIcon'
import Suisse from '../../../frontend-lib/typhograpy/Suisse'
import ChevronRightIcon from '../../../frontend-lib/icons/ChevronRightIcon'

const getHeader = ({ t, section }) => {
  const header = {
    home: (
      <Box sx={{ borderBottom: '1px solid rgba(31, 36, 45, 0.1)' }}>
        <SangBleu
          size={32}
          color="mono.black"
          align="left"
          sx={{
            pb: 5,
            pt: { xs: 8, md: 10 },
            px: { sm: '40px', xs: '24px' },
            width: '100%',
            maxWidth: { sm: '1041px', xs: '600px' },
          }}
          component="h2"
        >
          {t('home.features.title')}
          <span style={{ color: '#6665DD' }}>{t('home.features.title1')}</span>
          {t('home.features.title2')}
        </SangBleu>
      </Box>
    ),
    banks: (
      <Box sx={{ borderBottom: '1px solid rgba(31, 36, 45, 0.1)' }}>
        <SangBleu
          size={32}
          color="purple.3"
          align="left"
          sx={{
            pb: 5,
            pt: { xs: 8, md: 10 },
            px: { sm: '40px', xs: '24px' },
            width: '100%',
            maxWidth: { sm: '1041px', xs: '600px' },
          }}
          component="h2"
        >
          {t(`${section}.features.title`)}
        </SangBleu>
      </Box>
    ),
    insurance: (
      <Box sx={{ borderBottom: '1px solid rgba(31, 36, 45, 0.1)' }}>
        <SangBleu
          size={32}
          color="purple.3"
          align="left"
          sx={{
            pb: 5,
            pt: { xs: 8, md: 10 },
            px: { sm: '40px', xs: '24px' },
            width: '100%',
            maxWidth: { sm: '1041px', xs: '600px' },
          }}
          component="h2"
        >
          {t(`${section}.features.title`)}
        </SangBleu>
      </Box>
    ),
  }
  return header[section]
}
function FeaturesMobile({ ITEMS, t, section }) {
  const [checked, setChecked] = useState({ option: 1 })
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        bgcolor: 'mono.white',
        pb: { xs: 7, sm: 0 },
        borderTop: '1px solid rgba(31, 36, 45, 0.1)',
      }}
    >
      {getHeader({ t, section })}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          pt: 6,
          px: '16px',
        }}
      >
        <BaseButton
          color="calm"
          isAlternative
          size="small"
          onClick={() =>
            setChecked({
              option: checked.option === 1 ? 1 : checked.option - 1,
            })
          }
          sx={{
            width: '48px',
            height: '48px',
            borderRadius: '16px',
            '&:hover': '#FFFFFF',
          }}
        >
          <ChevronLeftIcon size="custom" width={8} height={15} />
        </BaseButton>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            px: 1,
          }}
        >
          <Suisse color="mono.black" size={18} type="semibold" component="h3">
            {ITEMS.filter((item) => item.key === checked.option)[0]?.title}
          </Suisse>
          <Suisse color="grey.1" size={18} type="regular" align="center">
            {ITEMS.filter((item) => item.key === checked.option)[0]?.subtitle}
          </Suisse>
        </Box>
        <BaseButton
          color="calm"
          isAlternative
          size="small"
          onClick={() =>
            setChecked({
              option: checked.option === 7 ? 1 : checked.option + 1,
            })
          }
          sx={{
            width: '48px',
            height: '48px',
            borderRadius: '16px',
            '&:hover': '#FFFFFF',
          }}
        >
          <ChevronRightIcon size="custom" width={8} height={15} />
        </BaseButton>
      </Box>
      <Box>
        {ITEMS.map((item) => (
          <Fade
            in={checked.option === item.key}
            timeout={400}
            key={`fade-${item.key}`}
          >
            {checked.option === item.key ? (
              <Box
                key={`img-${item.key}`}
                sx={{
                  mt: 5,
                  px: { sm: 8, xs: 3 },
                  mb: { sm: 7 },
                  filter: 'drop-shadow(0px 0px 40px rgba(0, 0, 0, 0.1))',
                }}
              >
                {item.img}
              </Box>
            ) : (
              <Box />
            )}
          </Fade>
        ))}
      </Box>
    </Box>
  )
}

export default FeaturesMobile
